import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import BaseReelsConfig from '../../vendor_core/core/src/baseConfigs/BaseReelsConfig';
import IReelCascadeProps from '../../vendor_core/core/src/managers/contracts/configurations/reels/IReelCascadeProps';

class ReelsConfig extends BaseReelsConfig {
    numberOfReels: number = 6;
    numberOfSymbols: number = 5;
    cascadeProps: IReelCascadeProps = {
        ...this.cascadeProps,
        mainSpinProps: {
            ...this.cascadeProps.mainSpinProps,
            spinReelDelay: 80, // 100
            stopReelDelay: 80, // 100
            spinSymbolAnimTime: 400, // 500
            spinFirstSymbolAnimTime: 500, // 600
            stopFirstSymbolAnimTime: 350, // 400
            spinReelDelayInTurboMode: 30, // 0
            stopReelDelayInTurboMode: 20, // 0
            mainDropSpinEasing: "none",
            mainDropStopEasing: "back.out(0.4)",
        },
        dropRemainingProps: {
            ...this.cascadeProps.dropRemainingProps,
            easing: "back.out(0.6)",
            animationDuration: 130, // 200
            animationDurationInTurbo: 65, // 200
            delay: 20,
            delayInTurbo: 20,
        },
        fillRemainingProps: {
            ...this.cascadeProps.fillRemainingProps,
            easing: "back.out(0.4)",
            easingInTurboMode: "back.out(0.4)",
            animTime: 130, // 200
            animTimeInTurbo: 65, // 200
            symbolDelay: 15,
            symbolDelayInTurboMode: 15,
            reelDelay: 30,
            reelDelayInTurboMode: 30
        }
    }
}

export default new ReelsConfig()
